import React, { useState, useEffect } from 'react';
import NavBar from './layouts/NavBar';
import { Container, Button, Col, Table, Modal, Form, Badge, Card, Spinner, Alert, Row } from 'react-bootstrap';
import Footer from './layouts/Footer';
import { obtenerUsuarios, agregarUsuario, eliminarUsuario, obtenerRolesDeUsuario, actualizarRoles, cambiarPassword } from '../utils/Api';
//import { library } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { toast } from "react-toastify";

//import { 
//  faPlus, 
//  faEdit, 
//  faTrashAlt, 
//  faSave,
//  faSpinner
//} from '@fortawesome/free-solid-svg-icons';

const UsuariosSistema = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  
  const [nuevoUsuario, setNuevoUsuario] = useState({ 
    userName: '', 
    email: '', 
    roles: [],
    oldPassword: '',
    newPassword: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rolesOriginales, setRolesOriginales] = useState([]);

  const cargarUsuarios = async () => {
      try {
        setLoading(true);
        const data = await obtenerUsuarios();
        setUsuarios(data);
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
        setError('Error al cargar los usuarios. Intente nuevamente.');
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    cargarUsuarios();
  }, []);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setNuevoUsuario({ userName: '', email: '', roles: [] });
    setError(null);
    setShowModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNuevoUsuario({ ...nuevoUsuario, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setNuevoUsuario((prevState) => {
      const updatedRoles = checked
        ? [...prevState.roles, value]
        : prevState.roles.filter((rol) => rol !== value);
      return { ...prevState, roles: updatedRoles };
    });
  };

  const handleAgregarUsuario = async () => {
    if (!nuevoUsuario.userName.trim()) {
      setError("El nombre de usuario es obligatorio.");
      return;
    }

    if (!nuevoUsuario.email.trim()) {
      setError("Asigne un email para administrar la cuenta.");
      return;
    }

    if (nuevoUsuario.roles.length === 0) {
      setError("Debe asignar al menos un rol.");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        userName: nuevoUsuario.userName.trim(),
        roles: nuevoUsuario.roles
      };

      if (nuevoUsuario.email && nuevoUsuario.email.trim() !== '') {
        payload.email = nuevoUsuario.email.trim();
      }

    console.log("Usuario a enviar:", payload); // ← aquí

      const usuarioCreado = await agregarUsuario(payload);
      setUsuarios([...usuarios, usuarioCreado]);
      handleCloseModal();
    } catch (error) {
      console.error('Error al agregar usuario:', error);
      setError('Error al agregar el usuario. Intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleEditarUsuario = async (usuario) => {
    setModoEdicion(true);
    
    try {      
      const rolesAsignados = await obtenerRolesDeUsuario(usuario.userName);

      setNuevoUsuario({
        userName: usuario.userName,
        email: usuario.email,
        roles: rolesAsignados
      });
      
      setRolesOriginales(rolesAsignados);

      setModoEdicion(true);
      setModalVisible(true);
    } catch (error) {
      console.error("Error al obtener roles del usuario:", error);
    }

    setShowModal(true);
  };


  const handleEliminarUsuario = async (userName) => {
    if (window.confirm(`¿Estás seguro de eliminar al usuario ${userName}?`)) {
      try {
        await eliminarUsuario(userName);
        alert("Usuario eliminado");
        cargarUsuarios(); // o actualiza el listado
      } catch (error) {
        console.error(error);
        alert("Error al eliminar usuario");
      }
    }
  };

  const handleActualizarUsuario = async () => {
    try {
      setLoading(true);

      // Comparar con los roles originales que se cargaron al abrir el modal
      const rolesActuales = nuevoUsuario.roles || [];
      const rolesAEliminar = rolesOriginales.filter(r => !rolesActuales.includes(r));
      const rolesAAgregar = rolesActuales.filter(r => !rolesOriginales.includes(r));

      await actualizarRoles(nuevoUsuario.userName, rolesAAgregar, rolesAEliminar);

      // Si el usuario ingresó una nueva contraseña
      if (nuevoUsuario.newPassword && nuevoUsuario.newPassword.trim() !== "") {
        const cambioPassword = {
          userName: nuevoUsuario.userName,
          oldPassword: nuevoUsuario.oldPassword || "", // puede ser vacío si no se requiere
          newPassword: nuevoUsuario.newPassword
        };

        try {
          await cambiarPassword(cambioPassword);
          toast.success("Contraseña actualizada correctamente");
        } catch (error) {
          console.error("Error al cambiar la contraseña:", error);
          toast.error("Error al cambiar la contraseña");
        }
      }

      toast.success("Usuario actualizado exitosamente");
      setShowModal(false);
      setModoEdicion(false);
      setNuevoUsuario({ userName: "", email: "", roles: [], oldPassword: "", newPassword: "" });
      cargarUsuarios();
    } catch (error) {
      console.error("Error al actualizar el usuario:", error);
      toast.error("Error al actualizar el usuario");
    } finally {
      setLoading(false);
    }
  };


  return (
    <Container fluid className="p-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <NavBar />
      
      <Row className="justify-content-center">
        <Col xl={10} lg={12} md={12}>
          <Card className="shadow-lg border-0 rounded-lg">
            <Card.Header className="bg-primary text-white">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Gestión de Usuarios</h3>
                <Button variant="light" onClick={handleShowModal}>
                  <i className="fas fa-plus me-2"></i>Agregar Usuario
                </Button>
              </div>
            </Card.Header>
            
            <Card.Body>
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-3">Cargando usuarios...</p>
                </div>
              ) : error ? (
                <Alert variant="danger">{error}</Alert>
              ) : (
                <div className="table-responsive">
                  <Table striped bordered hover className="mb-0">
                    <thead className="table-light">
                      <tr>
                        <th width="5%">#</th>
                        <th width="25%">Nombre</th>
                        <th width="25%">Email</th>
                        <th width="30%">Roles</th>
                        <th width="15%">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usuarios.map((usuario, index) => (
                        <tr key={usuario.id || index}>
                          <td>{index + 1}</td>
                          <td>{usuario.userName || 'N/A'}</td>
                          <td>{usuario.email}</td>
                          <td>
                            {usuario.roles && Array.isArray(usuario.roles) && usuario.roles.length > 0 ? (
                              usuario.roles.map((rol, rolIndex) => (
                                <Badge key={rolIndex} pill bg={
                                  rol === 'Admin' || rol === 'Administrador_USUARIOS' ? 'danger' :
                                  rol.includes('Radisson') ? 'primary' : 'success' } className="me-1">
                                  {rol}
                                </Badge>
                              ))
                            ) : (
                              <Badge pill bg="secondary">Sin rol</Badge>
                            )}
                          </td>
                          <td>
                            <Button
                              variant="outline-warning"
                              size="sm"
                              onClick={() => handleEditarUsuario(usuario)}
                              className="me-2"
                            >
                              <i className="fas fa-edit"></i>
                            </Button>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleEliminarUsuario(usuario.userName)}
                            >
                              <i className="fas fa-trash-alt"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal para agregar usuario */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>{modoEdicion ? "Editar Usuario" : "Agregar Nuevo Usuario"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formNombreUsuario">
              <Form.Label className="fw-bold">Nombre de Usuario</Form.Label>
              <Form.Control
                type="text"
                name="userName"
                value={nuevoUsuario.userName || ""}
                onChange={handleInputChange}
                placeholder="Ej: juan.perez"
              />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label className="fw-bold">Email (opcional)</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={nuevoUsuario.email}
                onChange={handleInputChange}
                placeholder="Ej: juan.perez@ejemplo.com"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formRoles">
              <Form.Label className="fw-bold">Asignar Roles</Form.Label>
              <div className="border p-3 rounded">
                <Form.Check
                  id="rolAdministrador"
                  type="checkbox"
                  label="Administrador"
                  value="Administrador_USUARIOS"
                  checked={nuevoUsuario.roles.includes("Administrador_USUARIOS")}
                  onChange={handleCheckboxChange}
                  className="mb-2"
                />
                <Form.Check
                  id="rolRecepcionistaRadisson"
                  type="checkbox"
                  label="Recepcionista Radisson Blu"
                  value="Recepcionista_RADISSON"
                  checked={nuevoUsuario.roles.includes("Recepcionista_RADISSON")}
                  onChange={handleCheckboxChange}
                  className="mb-2"
                />
                <Form.Check
                  id="rolRecepcionistaHebro"
                  type="checkbox"
                  label="Recepcionista Ebro"
                  value="Recepcionista_EBRO"
                  checked={nuevoUsuario.roles.includes("Recepcionista_EBRO")}
                  onChange={handleCheckboxChange}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formOldPassword">
              <Form.Label className="fw-bold">Contraseña Actual (si aplica)</Form.Label>
              <Form.Control
                type="password"
                name="oldPassword"
                value={nuevoUsuario.oldPassword || ""}
                onChange={handleInputChange}
                placeholder="Ingrese su contraseña actual"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formNewPassword">
              <Form.Label className="fw-bold">Nueva Contraseña</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={nuevoUsuario.newPassword || ""}
                onChange={handleInputChange}
                placeholder="Ingrese nueva contraseña (opcional)"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={modoEdicion ? handleActualizarUsuario : handleAgregarUsuario} disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Guardando...
              </>
            ) : (
              <>
                <i className="fas fa-save me-2"></i>Guardar Usuario
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </Container>
  );
};

export default UsuariosSistema;